import { config } from '../config';
import { getHeaders } from './getHeaders';
import { getEmailOverrideParams } from './getEmailOverrideParams';

export const getUser = () =>
  fetch(
    `${
      config.apiBaseUrl
    }/api/v1/sales-consultants/me${getEmailOverrideParams()}`,
    {
      headers: getHeaders(),
    },
  );
